<div fxLayout="column" id="snackbar-component" [ngClass]="getClasses()">
  <div fxLayout="row" class="right">
    <button mat-icon-button id="snackbar-exit-button" (click)="snackBarRef.dismiss();">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div id="snackbar-text-box">
    <div>
      <mat-icon id="snackbar-icon">{{getMatIcon()}}</mat-icon>
      <span id="snackbar-header-text"> {{getNotificationHeader()}}</span>
    </div>
    <div>
      <span id="snackbar-message-text">{{getMessage()}}</span>
    </div>
  </div>
</div>
